import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';

export enum EnrichmentVisibility {
  ALL = '',
  PRIVATE = 'PRIVATE',
  INTERNAL = 'INTERNAL',
}

export const CONFIG: TableFilterSelectOption[] = [
  {
    key: EnrichmentVisibility.ALL,
    value: 'All Users',
  },
  {
    key: EnrichmentVisibility.PRIVATE,
    value: 'Mine',
  },
  {
    key: EnrichmentVisibility.INTERNAL,
    value: 'Team',
  },
];
